import nipplejs from 'nipplejs';

export class InputController {
    constructor() {
        // Control states
        this.up = false;
        this.down = false;
        this.left = false;
        this.right = false;
        
        // Set up keyboard controls
        this.setupKeyboardControls();
        
        // Set up joystick controls for touch devices
        this.setupJoystickControls();
    }
    
    setupKeyboardControls() {
        window.addEventListener('keydown', (event) => {
            this.handleKeyDown(event.code);
        });
        
        window.addEventListener('keyup', (event) => {
            this.handleKeyUp(event.code);
        });
    }
    
    handleKeyDown(code) {
        switch (code) {
            case 'ArrowUp':
            case 'KeyW':
                this.up = true;
                break;
            case 'ArrowDown':
            case 'KeyS':
                this.down = true;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                this.left = true;
                break;
            case 'ArrowRight':
            case 'KeyD':
                this.right = true;
                break;
        }
    }
    
    handleKeyUp(code) {
        switch (code) {
            case 'ArrowUp':
            case 'KeyW':
                this.up = false;
                break;
            case 'ArrowDown':
            case 'KeyS':
                this.down = false;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                this.left = false;
                break;
            case 'ArrowRight':
            case 'KeyD':
                this.right = false;
                break;
        }
    }
    
    setupJoystickControls() {
        const joystickZone = document.getElementById('joystick-zone');
        
        // Only set up joystick if the element exists and we're on a touch device
        if (joystickZone && this.isTouchDevice()) {
            const joystickOptions = {
                zone: joystickZone,
                mode: 'static',
                position: { left: '50%', top: '50%' },
                color: 'white',
                size: 120,
                restOpacity: 0.5
            };
            
            const joystick = nipplejs.create(joystickOptions);
            
            joystick.on('move', (event, data) => {
                const angle = data.angle.degree;
                const force = Math.min(data.force, 1);
                
                // Reset all directions
                this.up = false;
                this.down = false;
                this.left = false;
                this.right = false;
                
                // Threshold for direction activation (0-1)
                const threshold = 0.5;
                
                // Apply force threshold to determine if direction is active
                if (force > threshold) {
                    // Forward/backward (up/down) control
                    if (angle >= 315 || angle < 45) {
                        this.up = true;
                    } else if (angle >= 135 && angle < 225) {
                        this.down = true;
                    }
                    
                    // Left/right control
                    if (angle >= 225 && angle < 315) {
                        this.left = true;
                    } else if (angle >= 45 && angle < 135) {
                        this.right = true;
                    }
                }
            });
            
            joystick.on('end', () => {
                // Reset all directions when joystick is released
                this.up = false;
                this.down = false;
                this.left = false;
                this.right = false;
            });
        } else {
            // If not a touch device, hide joystick zone
            if (joystickZone) {
                joystickZone.style.display = 'none';
            }
        }
    }
    
    isTouchDevice() {
        return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
    }
} 